import { render, staticRenderFns } from "./QuestionSingle.vue?vue&type=template&id=96f85aae&scoped=true&"
import script from "./QuestionSingle.vue?vue&type=script&lang=js&"
export * from "./QuestionSingle.vue?vue&type=script&lang=js&"
import style0 from "./QuestionSingle.vue?vue&type=style&index=0&id=96f85aae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96f85aae",
  null
  
)

export default component.exports